


















































import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  computed: {
    answer(): {
      primary?: 'true' | 'false' | 'unknown';
      secondary?: string;
      notes?: string;
    } {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    primaryKeys(): string[] {
      return ['true', 'false', 'unknown'].filter(
        (key) =>
          key !== 'unknown' ||
          (key === 'unknown' && this.value.item.options.showUnknown)
      );
    },

    showPrimary(): boolean {
      return this.value?.item?.options?.showPrimary !== undefined
        ? this.value?.item?.options?.showPrimary
        : true;
    },
  },

  watch: {
    'answer.primary'() {
      if (this.answer.primary !== 'true') {
        this.answer.secondary = undefined;
      }
    },
  },

  methods: {
    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;
        if(this.showPrimary === true) {
          if (this.answer.primary !== undefined) {
            if (
              this.answer.primary === 'true' &&
              this.answer.secondary !== undefined
            ) {
              completeness++;
            } else if (this.answer.primary !== 'true') {
              completeness++;
            }
          }
        } else if (this.answer.secondary !== undefined) {
          completeness++;
        }
        this.value.data.participation.completeness = completeness / 1;
      }
    },
  },
});
